import { Trophy } from "lucide-react";

const CONF = [
  { pos: 2, color: "#C0C0C0", height: "h-20", label: "2°" },
  { pos: 1, color: "#FFD700", height: "h-28", label: "1°" },
  { pos: 3, color: "#CD7F32", height: "h-14", label: "3°" },
];

export default function Podium({ items = [], testidPrefix = "podium" }) {
  return (
    <div className="flex items-end justify-center gap-3 sm:gap-5 pt-4" data-testid={testidPrefix}>
      {CONF.map(({ pos, color, height, label }) => {
        const item = items.find((it) => it.pos === pos);
        return (
          <div key={pos} className="flex flex-col items-center gap-2 w-28 sm:w-36">
            <Trophy className="w-7 h-7" style={{ color }} />
            <p className="font-racing font-bold text-white text-xs sm:text-sm text-center truncate w-full px-1">
              {item ? item.title : "—"}
            </p>
            <p className="font-time text-[11px]" style={{ color }}>
              {item ? `${item.points} pt` : ""}
            </p>
            <div
              data-testid={`${testidPrefix}-${pos}`}
              className={`w-full ${height} rounded-t-xl border border-b-0 flex items-start justify-center pt-2`}
              style={{ borderColor: `${color}66`, background: `linear-gradient(180deg, ${color}22, transparent)` }}
            >
              <span className="font-racing font-black text-2xl" style={{ color }}>
                {label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
